import React, {useEffect} from 'react';
// import styles from '../homepage.module.css'
import styles from './ourStory.module.css'
import {useTranslation} from "react-i18next";
import LazyText from "../../common/imagescroll/LazyText";
// import Lazy from "../../../common/lazy-scroll/Lazy";
// import {HOME_PAGE_CONTENT} from "../homePageContent";

const OurStory: React.FC = () => {

    const { t, i18n } = useTranslation(); // Use the translation hook

    const pageTitle = "Custom Web Development, Software & Design Solutions in Kanata - XSCI";
    const metaDescriptionContent = "XSCI specializes in custom web development, responsive design, and software solutions in Kanata. " +
        "We help businesses grow with scalable, high-performing web apps and modern digital solutions. Get started with a custom project today!";
    // Set the meta description
    let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

    // The content you're trying to use for the meta description
    const descriptionContent = metaDescriptionContent;

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper_left}>
                <h4 className={"section_title"} style={{color:"darkturquoise"}}>Our Story</h4>
                <h2 className={"section_title"}>We were tired of seeing businesses overpay for unclear technology.</h2>
            </div>
            <div className={styles.content_wrapper_right}>
                XSCI was created to bring technology and business together through transparency and clarity.
                We believe digital solutions should be accessible, affordable, and built around real operational needs — not unnecessary complexity, hidden fees, or inflated promises.
                Our approach focuses on honest communication, thoughtful engineering, and long-term value for the businesses we work with.
            </div>
        </section>
    );
};

export default OurStory;
